<template>
    <div>
        <Box :title="'申请列表('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
            <LoadingFooter
                v-model="loading"
                :finished="finished"
                @load="onLoad"
                @scroll="IsSee=false"
            >
                <div class="items listItems" v-for="(item, index) in list" @click="$router.push({name: 'Ask', params: {item:item,CGJEBZ:CGJEBZ} })">
                    <div class="itemTopBox">
                        <div>
                            <span>申请单号</span>
                            <span>{{item.DH}}</span>
                        </div>
                        <div>
                            <span>申请科室</span>
                            <span>{{item.KSMC}}</span>
                        </div>
                        <div>
                            <span>申请日期</span>
                            <span>{{item.RQ}}</span>
                        </div>
                        <div>
                            <span>申请人</span>
                            <span>{{item.ZDRXM}}</span>
                        </div>
                        <div>
                            <span>申请设备</span>
                            <span>{{item.SQSBMX}}</span>
                        </div>
                        <div>
                            <span>申请理由</span>
                            <span>{{item.SQYY}}</span>
                        </div>
                        <div>
                            <span>申请标志</span>
                            <span>{{item.SHBZ}}</span>
                        </div>
                    </div>
                    <div v-if="item.ZT=='1'||item.ZT=='2'"  class="itemBottomBox"><!--状态为审核中和已审核不能修改和删除-->
                       <div>查看</div>
                    </div>
                    <div v-else class="itemBottomBox">
                       <div @click.stop="_delete(item, index)">删除</div>
                       <div>修改</div>
                    </div>

                </div>
            </LoadingFooter>
             <transition name="fade">
            <div class="menu" v-if="IsSee">
                <Field title="设备名称" placeholder="请输入" @onMessage="value => search.SBMC = value"/>

               <Field title="有无收费标准" type="teb"  :tabSelected="params.YWSFBZ==='有'?'0':'1'" :data="[{id:'0',name:'有'},{id:'1',name:'无'}]"
                @onMessage="value => params.YWSFBZ = value.name"/>

                <Field title="审核状态" type="teb" :tabSelected="search.SHZT" :data="[{id:'0',name:'未审核'},{id:'2',name:'审核中'},
                {id:'1',name:'已审核'},{id:'',name:'全部'}]"  @onMessage="value => search.SHZT = value.id"/>

              <!--  <Field title="计划类型" type="teb" :tabSelected="search.JHLX" :data="[{id:'0',name:'科室申请'},{id:'1',name:'年度计划'}]"
                 @onMessage="value => search.JHLX = value.id"/> -->
                <Field title="申请科室" :text="search.SQKSMC" name="departmentList" @manuconfirm="search.SQKS=arguments[0].a,search.SQKSMC=arguments[0].b"
                type="manufacturer" placeholder="请选择" />
                <Field title="开始时间" :text="search.StartTime" placeholder="请选择" type="calendar" @onMessage="value => search.StartTime = value"/>
                <Field title="结束时间" :text="search.EndTime"  placeholder="请选择" type="calendar" @onMessage="value => search.EndTime = value"/>
                <div class="search" @click="serach">查询</div>
            </div>
            </transition>
        </Box>
        <div class="footer">
            <div class="button" @click="$router.push({name:'Ask',params: {CGJEBZ:CGJEBZ}})">新增申请</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'AskList',
        data() {
            return {
                params:{
                    YWSFBZ:'有'
                },
                search:{//搜索条件
                    SQKS: null,
                    SBMC: null,
                    JHLX: '0',
                    SHZT: '0',
                    StartTime: '',
                    EndTime: ''
                },

                loading: true,
                finished: false,
                IsSee:false,
                list: [],
                page:5,
                CGJEBZ:'0',
                Total:0
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated() {
            this.loadDataDefault();
        },
        methods: {
            serach() {//搜索条件
                this.list=[];
                this.page=5;
                this.IsSee=false;
                this.loadDataDefault();
            },
            loadDataDefault(){
                this.$post('api/SBSG/SBSGList',{
                    PageIndex:1,
                    PageSize:this.page,
                    StartDate:this.search.StartTime,
                    EndDate:this.search.EndTime,
                    SHZT:this.search.SHZT,
                    KS:this.search.SQKS,
                    SBMC:this.search.SBMC,
                    NDJH:this.search.JHLX,
                    Store:this.$UserInfo.StoreCode,
                    GKHM:this.$UserInfo.UserId,
                    Token:'YTDF5EF3A6174564E5981A446158F106'
                }).then(result=>{
                    this.CGJEBZ=result.CGJEBZ;
                    this.Total=result.Total;
                    this.list=result.rows;
                    if(this.page<=this.Total)
                    {
                        this.loading=false;
                        this.finished=false;
                    }else this.finished=true;
                    
                })
            },onLoad() {//下拉加载页面
                if(!this.loading&&!this.finished){
                    this.page+=5;
                    this.loadDataDefault();
                }
            },
            _delete(item, index) {//删除申请单
               this.$Dialog.confirm({
                   message:"确定删除?"
               }).then(()=>{
                   this.$get('api/SBSG/DelEquApply',{
                       Token:'YTDF5EF3A6174564E5981A446158F106',
                       Store:this.$UserInfo.StoreCode,
                       DH:item.DH
                   }).then(result=>{
                       if (result.Status) {
                           this.$Toast(result.Msg);
                           this.list.splice(index,1);
                           this.Total=this.Total-1;
                       }else{
                           this.$Toast(result.Msg);
                       }
                   })
               }).catch(()=>{})
            },AddAsk(){

            }
        },
    }
</script>

<style scoped lang="scss">
    .menu{
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        transition: all .5s;
        .items{
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;
            span{
                flex: 1;
            }
            input{
                width: 215px;
                font-size: 29px;
                text-align: center;
                &::-webkit-input-placeholder{
                    color: #858585;
                }
            }
        }
        .search{
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }
    .items{
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;
        .itemTopBox{
            border-bottom: 2px solid #eee;
            div{
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;
                span:first-child{
                    flex: 1;
                    color: #858585;
                }
                span:last-child{
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }
        .itemBottomBox{
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            div{
                width: 300px;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                &:first-child{
                    background: #dedede;
                    color: #858585;
                    margin-right: 42px;
                }
                &:last-child{
                    background: $THEME-COLOR;
                    color: #fff;
                }
            }
        }
    }
    .listLength{
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;
        top:95px;
        span{
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
    .listLength{
        //top: 930px;
    }
    .listItems:nth-child(3){
        margin-top: 0px;
    }
    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/askList/askList.vue